import React from 'react';

import {
  renderText,
  renderCtaLink,
  renderSecondaryHeading,
} from '../../FeatureComponents/FullWidthRichText/fieldsRenderer';

const FeatureAnnouncementPanel = ({ fields }) => {
  //const isCtaInverted = useInvertedButton(fields);
  //const trackingAttributes = getTrackingAttributes(fields);
  return (
    <div className="c-row" style={{ marginTop: '32px' }}>
      <div className="c-col">
        {renderSecondaryHeading({
          field: fields?.Title,
          classes: 'c-full-width-rich-text__primary-heading-for-columns',
        })}
        {renderText({ field: fields?.Description, classes: 'c-full-width-rich-text__text' })}
        {renderCtaLink({ field: fields?.CTA, classes: ' u-margin-bottom-2' })}
      </div>
    </div>
  );
};

export default FeatureAnnouncementPanel;
